export interface MembershipPlanPriceDisplay {
  /** Formatted currency amount only, e.g. "₹75,000" */
  amount: string;
  /** Billing suffix without slash, e.g. "mo" — null for free plans */
  cycle: string | null;
  gstLine: string | null;
}

/** Indian grouping (lakhs/thousands) + billing cycle; GST note for paid plans. */
export function formatMembershipPlanPrice(
  price: number,
  currency: string,
  billingCycle: string,
): MembershipPlanPriceDisplay {
  if (!Number.isFinite(price) || price === 0) {
    return { amount: "Free", cycle: null, gstLine: null };
  }

  const code = (currency || "INR").trim().toUpperCase();
  const cycleSuffix = billingCycle === "yearly" ? "yr" : "mo";

  let amountFormatted: string;
  try {
    amountFormatted = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: code,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(price);
  } catch {
    const prefix =
      code === "INR" ? "₹" : code === "USD" ? "$" : `${code} `;
    amountFormatted = `${prefix}${Number(price).toLocaleString("en-IN")}`;
  }

  return {
    amount: amountFormatted,
    cycle: cycleSuffix,
    gstLine: "+18% GST",
  };
}
